import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import UserDataService from "../../services/user-data-service/UserDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";

type MutationContextType = {
    previous: string | undefined;
};

export type SaveUserImageParams = {
    groupID: number,
    userID: number, 
    file: File
};


export function useSaveUserImage(params: BaseUseMutationParameters<void, SaveUserImageParams>) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, SaveUserImageParams, MutationContextType>((data) => {
        return UserDataService.saveUserImage(data.groupID, data.userID, data.file)

    },{
        onError: params.onError,
        onSuccess: params.onSuccess,
        onSettled: (_data, error, _userSettings, context) => {
                if (error && context?.previous) {
                    queryClient.setQueryData<string>(
                        keys.settings(),
                        context?.previous
                    );
                }
                queryClient.invalidateQueries(keys.all);
            }
        }
    );
}
